<template>
  <div>
    <div class="media" v-if="Recom">
      <figure class="media-left">
        <p class="image logo">
          <img :src="getImg(pointDeVente.srcImg)">
        </p>
      </figure>
      <div class="media-content">
        <h3 v-if="libelle"
            class="has-text-weight-bold is-size-18px has-text-grid-1">
          {{libelle}}
        </h3>
        <p class="is-size-7 has-text-default" v-if="Recom.dateCreation">
          {{formatDate(Recom.dateCreation)}}
        </p>
        <p class="is-size-7 has-text-default is-italic">
          Proposition sous réserve de disponibilité
        </p>
      </div>
      <div class="media-right"></div>
    </div>
    <div class="card mt-30" v-if="Recom && commentaire">
      <div class="card-content pa-20">
        <img class="positionLight" src="@/assets/images/img_ampoule.svg">
        <p class="title is-size-14px has-text-weight-bold has-text-grid-1 mb-0">
          Notre préconisation
        </p>
        <p class="subtitle is-size-14px has-text-default mt-10 mb-10">
          {{commentaire}}
        </p>
      </div>
    </div>
    <div class="card mt-20">
      <div class="card-content pa-20 title is-size-14px has-text-weight-bold has-text-grid-1">
        <p class="mb-0">
          Le montant de la TLPE pourra varier lors de l’édition des contrats des régies
        </p>
        <p class="mt-10">
          Les dispositifs proposés sont sous réserve de disponibilité au moment de la validation
        </p>
        <p class="mt-10">
          Les fiches jaunes concernent des panneaux en cours de renouvellement
        </p>
        <p class="mt-10">
          Les fiches rouges concernent des panneaux non renouvelés
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatDate, getImg } from '@/services/general/general';

const Recommandation = createNamespacedHelpers('recommandation');
const User = createNamespacedHelpers('user');

export default {
  data: () => ({
  }),
  computed: {
    ...User.mapGetters({
      site: 'site',
    }),
    ...Recommandation.mapGetters({
      Recom: 'recom',
      societe: 'societe',
    }),
    pointDeVente() {
      return this.Recom.data.pointDeVentes[0];
    },
    commentaire() {
      return this.Recom.data.commentaire;
    },
    libelle() {
      if (this.Recom.themeCampagne) {
        return `${this.pointDeVente.libelle} - ${this.Recom.themeCampagne}`;
      }
      return `${this.pointDeVente.libelle}`
    }
  },
  methods: {
    formatDate(date) {
      return formatDate(date);
    },
    getImg(img) {
      var afficheImageGenerique = false;
      // if (this.site === 'havas') afficheImageGenerique = true;
      if (this.societe?.nom === 'STEFFEN') afficheImageGenerique = true;
      return getImg(img,afficheImageGenerique);
    },
  },
  metaInfo() {
    return {
      title: this.Recom.data.pointDeVentes[0].libelle,
      htmlAttrs: {
        lang: 'fr',
        amp: true
      }
    }
  },
}
</script>

<style>

</style>